var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAvatarSquares(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 392,
    height: 229,
    viewBox: "0 0 392 229",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M293 1.5L390 60L292.612 116.25L390 172.5L292.612 227.5L195.224 172.5L100 227.5L2 172.5L100 114.912L2 58.2062L100 1.5L196.5 58.2062L293 1.5Z",
    fill: "#1E1D22"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M195.224 172.5L100 227.5L2 172.5L100 114.912M195.224 172.5L100 114.912M195.224 172.5L292.612 116.25M195.224 172.5L292.612 227.5L390 172.5L292.612 116.25M100 114.912L196.5 58.2062M100 114.912L2 58.2062L100 1.5L196.5 58.2062M292.612 116.25L390 60L293 1.5L196.5 58.2062M292.612 116.25L196.5 58.2062",
    stroke: "black",
    strokeDasharray: "16 16"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M100 114.912L195.224 172.5L292.612 116.25L196.5 58.2062L100 114.912Z",
    stroke: "#DEEF76",
    strokeDasharray: "16 16"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarSquares);
export default __webpack_public_path__ + "static/media/avatar-squares.ec3111aa25d4a922aacdcba9d6dc41ea.svg";
export { ForwardRef as ReactComponent };